











import Vue from 'vue'
import { HeavyTicketDto } from '@/Application/Expediente'

export default Vue.extend({
  name: 'HeavyTicketsRow',
  components: { },
  props: {
    heavyTicket: {
      type: Object as () => HeavyTicketDto,
      required: true
    },
    modoAlleamento: {
      type: String,
      required: true
    },
    grouped: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    specieHeaderContent (): string {
      return this.grouped === false
        ? this.heavyTicket.especie + ' - ' + this.heavyTicket.forma
        : this.heavyTicket.especie
    }
  }
})
